import { RemoteData } from './utils/remoteData';
import { Omraader, transformOmraader } from './components/AreaSelect';
import axios from 'axios';

const rapportHeaders = {
  'X-client': 'NVDB-Rapporter-Frontend-Gammel',
};

export async function getOmraader(apiPath: string): Promise<RemoteData<Error, Omraader>> {
  try {
    const result = await axios.get(`${apiPath}/omraader`, {
      headers: rapportHeaders,
    });
    const decodedOmraade = Omraader.decode(result.data);
    if (result.status !== 200) throw 'Server error';
    return decodedOmraade.caseOf({
      Left: error =>
        ({
          type: 'FAILURE',
          error: { message: error },
        } as RemoteData<Error, Omraader>),
      Right: data =>
        ({
          type: 'SUCCESS',
          data: transformOmraader(data),
        } as RemoteData<Error, Omraader>),
    });
  } catch (error) {
    return { type: 'FAILURE', error };
  }
}
